module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "epigraphPage",
    attrs: {
      "id": "epi01"
    }
  }, [_c('div', {
    staticClass: "epigraph"
  }, [_c('p', {
    staticClass: "epigraphText"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Men say I am a saint losing himself in politics. The fact is that I am a politician trying my hardest to become a saint")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "epigraphSource"
  }, [_vm._v("Mahatma Gandhi")])]), _vm._v(" "), _c('div', {
    staticClass: "epigraph"
  }, [_c('p', {
    staticClass: "epigraphText"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Saints should always be judged guilty until they are proved innocent.")])]), _vm._v(" "), _c('p', {
    staticClass: "epigraphSource"
  }, [_vm._v("George Orwell")])]), _vm._v(" "), _c('div', {
    staticClass: "epigraph"
  }, [_c('p', {
    staticClass: "epigraphText"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("In wrath the Liberator shall descend into Thargland. The gods shall nee before him; they shall bow their heads before him, they will spread their hands before his feet.")])]), _vm._v(" "), _c('p', {
    staticClass: "epigraphSource"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Filoby Testament, 1001")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76f47f4f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/futureindefinite_epi01.vue
// module id = 78
// module chunks = 0